module.exports = __webpack_public_path__ + "img/電気回路_3_3_3.128c3135.png";